import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { CustomerHobbyPetInfo } from '../../../../models/customer.model';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';


@Component({
  selector: 'app-customer-hobbypetinfo',
  templateUrl: './hobbypetinfo.component.html'
})
export class CustomerDetailHobbyPetInfoComponent implements OnInit {

  @Input() customerId: string;
  @Output() dirtyFormData = new EventEmitter();

  validationData = null;
  formData: FormGroup;
  titlePage: string = 'customerDetail.addNew';

  constructor (
    private fb: FormBuilder,
    private srvCustomer: CustomerInfoService,
    private formValidation: FormValidationService
  ) {

  }

  ngOnInit(): void {
    this.srvCustomer.getHobbyPetInfo(this.customerId).subscribe((res) => {
      this.createForm(res);
    });
  }

  onChanges(): void {
    this.formData.valueChanges.subscribe(() => this.dirtyFormData.emit(this.formData.dirty));
  }


  evaluateFormControlName(prefix: string, index) : string {
    return prefix.concat('_').concat((index + 1).toString());
  }

  evaluateLength(count: number) {
    const array = [];

    for (let i = 0; i < count; i++) {
      array.push(i);
    }

    return array;
  }

  createForm(data: CustomerHobbyPetInfo) {
    const isNew = data == null;

    this.formData = this.fb.group({
      'flag_hobby_1': new FormControl(!isNew ? +data.flag_hobby_1 : false),
      'flag_hobby_2': new FormControl(!isNew ? +data.flag_hobby_2 : false),
      'flag_hobby_3': new FormControl(!isNew ? +data.flag_hobby_3 : false),
      'flag_hobby_4': new FormControl(!isNew ? +data.flag_hobby_4 : false),
      'flag_hobby_5': new FormControl(!isNew ? +data.flag_hobby_5 : false),
      'flag_hobby_6': new FormControl(!isNew ? +data.flag_hobby_6 : false),
      'flag_hobby_7': new FormControl(!isNew ? +data.flag_hobby_7 : false),
      'flag_hobby_8': new FormControl(!isNew ? +data.flag_hobby_8 : false),
      'flag_hobby_9': new FormControl(!isNew ? +data.flag_hobby_9 : false),
      'flag_hobby_10': new FormControl(!isNew ? +data.flag_hobby_10 : false),
      'flag_hobby_11': new FormControl(!isNew ? +data.flag_hobby_11 : false),
      'flag_hobby_12': new FormControl(!isNew ? +data.flag_hobby_12 : false),
      'pet_1': new FormControl(!isNew ? +data.pet_1 : null, KoncentroValidators.integerNotNegative),
      'pet_2': new FormControl(!isNew ? +data.pet_2 : null, KoncentroValidators.integerNotNegative),
      'pet_3': new FormControl(!isNew ? +data.pet_3 : null, KoncentroValidators.integerNotNegative),
      'pet_4': new FormControl(!isNew ? +data.pet_4 : null, KoncentroValidators.integerNotNegative),
      'other_pet': new FormControl(!isNew ? +data.other_pet : null, KoncentroValidators.integerNotNegative),
      'other_pet_name': new FormControl(!isNew ? +data.other_pet_name : null),
    });
    this.onChanges();
  }

  public customSave(): Observable<any> {
    if (!this.formData.valid) {
      this.formValidation.validateAllFormFields(this.formData);
      return Observable.of(false);
    }

    return this.srvCustomer.putHobbyPetInfo(this.customerId, this.formData.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/hobbypetinfo/hobbypetinfo.component.ts